/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
// import Login from "pages/authentication/sign-in";
// import Test from "pages/test";
import NewFile from "pages/file/newFile";
import Files from "pages/file/files";
import Templates from "pages/templates";
import EditFile from "pages/file/editFile";
import FileDetail from "pages/file/fileDetail";
import DocumentEditor from "pages/documentEditor";
import Calendar from "pages/calendar";
import Task from "pages/task";
import Dashboard from "pages/dashboard";
import Help from "pages/help";

// @mui icons
import Icon from "@mui/material/Icon";

// Key va a ser el item que se mantiene seleccionado en la barra
// Por ejemplo ruta detail con key file, va a mantener seleccionado el item file
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Nuevo expediente",
    key: "new_file",
    icon: <Icon fontSize="small">create_new_folder</Icon>,
    route: "/new_file",
    component: <NewFile />,
  },
  // ITEM Expedientes
  {
    type: "collapse",
    name: "Expedientes",
    key: "file",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/file",
    component: <Files />,
  },
  {
    name: "Detalle del expediente",
    key: "file",
    route: "/file/detail/:id",
    component: <FileDetail />,
  },
  {
    name: "Editar documento",
    key: "file",
    route: "/file/detail/:id/document/:documentId",
    component: <DocumentEditor />,
  },
  {
    name: "Editar archivo",
    key: "file",
    route: "/file/edit/:id",
    component: <EditFile />,
  },
  {
    type: "collapse",
    name: "Calendario",
    key: "calendar",
    icon: <Icon fontSize="small">calendar_month</Icon>,
    route: "/calendar",
    component: <Calendar />,
  },
  {
    type: "collapse",
    name: "Tareas",
    key: "task",
    icon: <Icon fontSize="small">checklist</Icon>,
    route: "/task",
    component: <Task />,
  },
  {
    type: "collapse",
    name: "Plantillas",
    key: "template",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/template",
    component: <Templates />,
  },
  { type: "divider", key: "divider-help" },
  {
    type: "collapse",
    name: "Centro de ayuda",
    key: "help",
    icon: <Icon fontSize="small">help_outline</Icon>,
    route: "/help",
    component: <Help />,
  },
  // {
  //   type: "collapse",
  //   name: "Test",
  //   key: "test",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/test",
  //   component: <Test />,
  // },
];

export default routes;
